import React from 'react';
import { Button } from 'react-bootstrap';

import './card.scss';

class Card extends React.Component {

  render() {

    const style = { backgroundImage: `url(${this.props.backgroundImage})` };

    return (
      <div className="welcome-card-component" style={style}>
        <div className="welcome-card-component__overlay">
          <h5 className="welcome-card-component__header"><strong>{this.props.header}</strong></h5>
          <div className="welcome-card-component__content">
            <h2 className="welcome-card-component__title"><strong>{this.props.title}</strong></h2>
            <p>{this.props.text}</p>
            <Button className="welcome-card-component__link" bsStyle="link" block href={this.props.buttonLink} target={this.props.externalLink ? "_blank" : "_self" }>{this.props.buttonText} ></Button>
          </div>
        </div>
      </div>
    );
  }
}

Card.displayName = 'PagesWelcomeCard';
Card.propTypes = {};
Card.defaultProps = {};

export default Card;



// WEBPACK FOOTER //
// ./components/pages/welcome/Card.js